import {
  CALCULATION_RENAME_REQUEST,
  CALCULATION_RENAME_CANCEL,
  CALCULATION_RENAME,

  CALCULATION_REMOVE_REQUEST,
  CALCULATION_REMOVE_CANCEL,
  CALCULATION_REMOVE,

  CALCULATION_CREATE,
  CALCULATION_CREATE_REQUEST,
  CALCULATION_CREATE_CANCEL,

} from './calculation';

import {
  CANCEL_PROJECT_REMOVE,
  PROJECT_REMOVE,
  PROJECT_REMOVE_REQUEST
} from './projects';

import { adobeClickOpenSaveAsPDFModal } from '../utils/analytics';

// Actions
const PREFIX = 'calculus/app/';

export const INITIALIZE_PROGRAM  = PREFIX + 'INITIALIZE_PROGRAM';
export const PDF_CREATE_REQUEST  = PREFIX + 'PDF_CREATE_REQUEST';
export const PDF_CREATE_CANCEL  = PREFIX + 'PDF_CREATE_CANCEL';
export const PDF_CREATE  = PREFIX + 'PDF_CREATE';
export const PDF_CREATED  = PREFIX + 'PDF_CREATED';
export const PDF_ERROR  = PREFIX + 'PDF_ERROR';
export const CHANGE_LANGUAGE  = PREFIX + 'CHANGE_LANGUAGE';

export const OPEN_SETTINGS  = PREFIX + 'OPEN_SETTINGS';
export const CLOSE_SETTINGS  = PREFIX + 'CLOSE_SETTINGS';

export const SET_LOCALIZATION  = PREFIX + 'SET_LOCALIZATION';
export const TOGGLE_SPLASH_SCREEN  = PREFIX + 'TOGGLE_SPLASH_SCREEN';

export const OPEN_LOGIN  = PREFIX + 'OPEN_LOGIN';
export const CLOSE_LOGIN  = PREFIX + 'CLOSE_LOGIN';

export const OPEN_SAVE_PROJECT_DIALOG  = PREFIX + 'OPEN_SAVE_PROJECT_DIALOG';
export const CLOSE_SAVE_PROJECT_DIALOG  = PREFIX + 'CLOSE_SAVE_PROJECT_DIALOG';

export const IS_USER_LOGGED_IN  = PREFIX + 'IS_USER_LOGGED_IN';
export const CHECK_PROJECTS_FOR_NOT_FOUND_ITEMS  = PREFIX + 'CHECK_PROJECTS_FOR_NOT_FOUND_ITEMS';

// Set country and language on index.html
const INITIAL_STATE = {
  language: null,
  country: null,
  initialized: false,
  creatingPDF: false,
  pdfError: false,
  calculationCreateDialogOpen: false,
  calculationRenameDialogOpen: false,
  calculationRemoveDialogOpen: false,
  splashScreenDialogOpen: false,
  printPdfDialogOpen: false,
  pdfOptions: {},
  projectDetailsOpen: false,
  createNewProjectOpen: false,
  projectRemoveDialogOpen: false,
  settingsOpen: false,
  settingsMenuLayout: 0,

  projectSaveDialogOpen: false,

  loginOpen: false,
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case INITIALIZE_PROGRAM:

      const loaderAnimation = document.getElementById('loading-animation');
      loaderAnimation.classList.add('fadeOut');

      return {
        ...state,
        initialized: true,
        splashScreenDialogOpen: true
      };

    case SET_LOCALIZATION:

      const language = payload ? payload.language ? payload.language : app_language : app_language;
      const country  = payload ? payload.country ? payload.country : app_country : app_country;

      return {
        ...state,
        language: language,
        country: country
      };

    case PDF_CREATE_REQUEST:
      adobeClickOpenSaveAsPDFModal();
      return {
        ...state,
        printPdfDialogOpen: true
      };

    case PDF_CREATE_CANCEL:
      return {
        ...state,
        printPdfDialogOpen: false,
        creatingPDF: false
      };

    case PDF_CREATE:
      return {
        ...state,
        printPdfDialogOpen: false,
        creatingPDF: true,
        pdfError: false,
        pdfOptions: payload,
      };

    case PDF_CREATED:
      return {
        ...state,
        creatingPDF: false,
        pdfError: false
      };

    case PDF_ERROR:
      return {
        ...state,
        creatingPDF: false,
        pdfError: true
      };

    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: payload
      };

    case CALCULATION_CREATE_REQUEST:
      return {
        ...state,
        calculationCreateDialogOpen: true,
      };

    case CALCULATION_CREATE:
    case CALCULATION_CREATE_CANCEL:
      return {
        ...state,
        calculationCreateDialogOpen: false,
      };

    case CALCULATION_RENAME_REQUEST:
      return {
        ...state,
        calculationRenameDialogOpen: true,
      };

    case CALCULATION_RENAME:
    case CALCULATION_RENAME_CANCEL:
      return {
        ...state,
        calculationRenameDialogOpen: false,
      };

    case CALCULATION_REMOVE_REQUEST:
      return {
        ...state,
        calculationRemoveDialogOpen: true,
      };

    case CALCULATION_REMOVE:
    case CALCULATION_REMOVE_CANCEL:
      return {
        ...state,
        calculationRemoveDialogOpen: false,
      };
    case OPEN_SETTINGS:
      return {
        ...state,
        settingsOpen: true,
        settingsMenuLayout: payload ? payload : 0
      };

    case CLOSE_SETTINGS:
      return {
        ...state,
        settingsOpen: false,
        settingsMenuLayout: 0,
      };

    case PROJECT_REMOVE:
    case CANCEL_PROJECT_REMOVE:
      return {
        ...state,
        projectRemoveDialogOpen: false,
      };

    case PROJECT_REMOVE_REQUEST:
      return {
        ...state,
        projectRemoveDialogOpen: true,
      };

    case TOGGLE_SPLASH_SCREEN:
      return {
        ...state,
        splashScreenDialogOpen: !state.splashScreenDialogOpen,
      };

    case OPEN_LOGIN:
      return {
        ...state,
        loginOpen: true,
      };

    case CLOSE_LOGIN:
      return {
        ...state,
        loginOpen: false,
      };

    default:
      return state;
  }
}

// Action Creators
/*
export function patchProject(payload) {
  return {
    type: PROJECT_ADD,
    payload: payload
  }
}
*/

export function initializeProgram() {
  return {
    type: INITIALIZE_PROGRAM
  };
}

export function checkIfUserIsLoggedIn(payload) {
  return {
    type: IS_USER_LOGGED_IN,
    payload: payload
  };
}

export function pdfCreateRequest() {
  return {
    type: PDF_CREATE_REQUEST
  };
}

export function pdfCreateCancel() {
  return {
    type: PDF_CREATE_CANCEL
  };
}

export function pdfCreate(payload) {
  return {
    type: PDF_CREATE,
    payload: payload
  };
}

export function pdfCreated() {
  return {
    type: PDF_CREATED
  };
}

export function changeLanguage(payload) {
  return {
    type: CHANGE_LANGUAGE,
    payload: payload
  };
}

export function openSetting(payload) {
  return {
    type: OPEN_SETTINGS,
    payload: payload
  };
}

export function closeSetting() {
  return {
    type: CLOSE_SETTINGS,
  };
}

export function setLocalization(payload) {
  return {
    type: SET_LOCALIZATION,
    payload: payload
  };
}

export function toggleSplashScreen() {
  return {
    type: TOGGLE_SPLASH_SCREEN,
  };
}

export function openLogin() {
  return {
    type: OPEN_LOGIN
  };
}

export function closeLogin() {
  return {
    type: CLOSE_LOGIN
  };
}

export function checkProjectsForNotFoundItems() {
  return {
    type: CHECK_PROJECTS_FOR_NOT_FOUND_ITEMS
  };
}
